export const IsAppendTableContext = (manager: any): boolean => {
  return manager?.GetManagerName?.() === "tableManager";
};
